import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'amenities',
  namespace: 'amenity',
  mountedUrl: '/amenities',
  title: 'Amenities',
  columns: [
    { attribute: 'name' },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/amenity/containers/Listing.jsx